import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DocumentEditItemComponent } from './edit-item.component';
import { DocumentEditItemSitemapComponent } from './sitemap/sitemap.component';
import { DocumentEditItemSimpleTextComponent } from './simple-text/simple-text.component';
import { DocumentEditItemSimpleTextPanelComponent } from './simple-text-panel/simple-text-panel.component';
import { DocumentEditItemAdvancedTextComponent } from './advanced-text/advanced-text.component';
import { DocumentEditItemAdvancedTextPanelComponent } from './advanced-text-panel/advanced-text-panel.component';
import { FiDocumentEditSitemapHandlerComponent } from './sitemap-handler/sitemap-handler.component';
import { FiDocumentEditItemSitemapDialogComponent } from './sitemap-dialog/sitemap-dialog.component';
import { DocumentEditImageHandlerComponent } from './image-handler/image-handler.component';
import { FiAppTextSharedModule } from '@fi-app/shared/app-text';
import { FiTextPanelModule } from '@fi-app/shared/fi-text-panel/fi-text-panel.module';
import { WidgetModule } from '@fi-app/widget/widget.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatRadioModule,
        MatCheckboxModule,
        MatCardModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        FiAppTextSharedModule,
        FiTextPanelModule,
        WidgetModule,
    ],
    declarations: [
        DocumentEditItemComponent,
        FiDocumentEditSitemapHandlerComponent,
        FiDocumentEditItemSitemapDialogComponent,
        DocumentEditItemSitemapComponent,
        DocumentEditItemSimpleTextPanelComponent,
        DocumentEditItemSimpleTextComponent,
        DocumentEditImageHandlerComponent,
        DocumentEditItemAdvancedTextPanelComponent,
        DocumentEditItemAdvancedTextComponent,
    ],
    exports: [DocumentEditItemComponent],
})
export class DocumentEditItemModule {}
